import th from 'vuetify/es5/locale/th'

export default {
  ...th,

  common:{
    search: "ค้นหา"
  },
  actions: {
    more: "เพิ่มเติม",
  },
  appbar: {
    
  }
}